import { useEffect, useRef } from 'react';

/**
 * Sunucudan gelen SSE (Server-Sent Events) push'larını dinler.
 * Değişiklik geldiğinde `onRefresh(type)` çağrılır.
 *
 * @param {function} onRefresh - ({ type }) parametresiyle çağrılır
 * @param {boolean} enabled - false ise bağlantı kurulmaz
 */
export function useSSE(onRefresh, enabled = true) {
  const cbRef = useRef(onRefresh);
  cbRef.current = onRefresh;

  useEffect(() => {
    if (!enabled) return;

    const token = sessionStorage.getItem('restaflex_branch_token')
               || localStorage.getItem('restaflex_token');
    if (!token) return;

    let es;
    let retryTimeout;
    let retryDelay = 2000;

    const connect = () => {
      const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      es = new EventSource(`${apiBase}/api/events?token=${encodeURIComponent(token)}`);

      es.addEventListener('refresh', (e) => {
        try {
          const data = JSON.parse(e.data);
          cbRef.current(data);
        } catch {}
      });

      es.addEventListener('connected', () => {
        retryDelay = 2000; // bağlantı kurulunca retry süresini sıfırla
      });

      es.onerror = () => {
        es.close();
        // Exponential backoff: 2s → 4s → 8s → max 30s
        retryDelay = Math.min(retryDelay * 2, 30000);
        retryTimeout = setTimeout(connect, retryDelay);
      };
    };

    connect();

    return () => {
      clearTimeout(retryTimeout);
      if (es) es.close();
    };
  }, [enabled]);
}
